import React from 'react';
import { Check, Plus, Gift } from 'lucide-react';

const UpsellCard = ({ upsell, isSelected, onToggle, compact = false }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(price);
  };

  if (compact) {
    // Versão compacta para página do produto
    return (
      <button
        onClick={() => onToggle(upsell)}
        className={`w-full flex items-center gap-3 p-3 rounded-lg border-2 transition-all ${
          isSelected 
            ? 'border-[#C9A24D] bg-[#C9A24D]/10' 
            : 'border-[#2A2A2D] bg-[#1C1C1F] hover:border-[#3A3A3D]'
        }`}
        data-testid={`upsell-compact-${upsell.id}`}
      >
        <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
          isSelected 
            ? 'border-[#C9A24D] bg-[#C9A24D]' 
            : 'border-[#666]'
        }`}>
          {isSelected && <Check className="h-3 w-3 text-[#0F0F10]" />}
        </div>
        
        <div className="flex-1 text-left">
          <p className="text-[#EAEAEA] font-medium text-sm">{upsell.title}</p>
        </div>
        
        <span className="text-[#C9A24D] font-bold text-sm">
          +{formatPrice(upsell.price)}
        </span>
      </button>
    );
  }

  // Versão completa para carrinho/checkout
  return (
    <div 
      className={`bg-[#1C1C1F] border-2 rounded-xl p-4 transition-all ${
        isSelected 
          ? 'border-[#C9A24D] shadow-[0_0_20px_rgba(201,162,77,0.15)]' 
          : 'border-[#2A2A2D] hover:border-[#3A3A3D]'
      }`}
      data-testid={`upsell-card-${upsell.id}`}
    >
      <div className="flex gap-4">
        {/* Imagem */}
        <div className="w-16 h-16 bg-[#0F0F10] rounded-lg flex-shrink-0 overflow-hidden flex items-center justify-center border border-[#2A2A2D]">
          {upsell.image_url ? (
            <img 
              src={upsell.image_url} 
              alt={upsell.title} 
              className="w-full h-full object-contain p-1"
            />
          ) : (
            <Gift className="h-6 w-6 text-[#C9A24D]" />
          )}
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <h4 className="text-[#EAEAEA] font-semibold text-sm mb-1">{upsell.title}</h4>
          {upsell.description && (
            <p className="text-[#666] text-xs line-clamp-2">{upsell.description}</p>
          )}
          <p className="text-[#C9A24D] font-bold mt-2">+{formatPrice(upsell.price)}</p>
        </div>

        {/* Toggle Button */}
        <button
          onClick={() => onToggle(upsell)}
          className={`self-center w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all flex-shrink-0 ${
            isSelected 
              ? 'border-[#C9A24D] bg-[#C9A24D] text-[#0F0F10]' 
              : 'border-[#666] text-[#666] hover:border-[#C9A24D] hover:text-[#C9A24D]'
          }`}
          aria-label={isSelected ? 'Remover do pedido' : 'Adicionar ao pedido'}
        >
          {isSelected ? (
            <Check className="h-5 w-5" />
          ) : (
            <Plus className="h-5 w-5" />
          )}
        </button>
      </div>

      {/* Selected indicator */}
      {isSelected && (
        <div className="mt-3 pt-3 border-t border-[#C9A24D]/30">
          <p className="text-xs text-[#C9A24D] flex items-center gap-1">
            <Check className="h-3 w-3" />
            Adicionado ao pedido
          </p>
        </div>
      )}
    </div>
  );
};

export default UpsellCard;
